import { render, staticRenderFns } from "./StreamTipsController.vue?vue&type=template&id=8590ec8c&scoped=true&"
import script from "./StreamTipsController.vue?vue&type=script&lang=ts&"
export * from "./StreamTipsController.vue?vue&type=script&lang=ts&"
import style0 from "./StreamTipsController.vue?vue&type=style&index=0&id=8590ec8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8590ec8c",
  null
  
)

export default component.exports